/**
 * Algolia Insights Plugin
 * Initializes Algolia Insights tracking on app load
 */
export default defineNuxtPlugin(() => {
  const { initInsights } = useAlgoliaInsights();
  
  // Initialize Algolia Insights
  if (process.client) {
    initInsights();
  }
});
